__turbopack_context__.v({
  "participantButton": "Qblt0W_participantButton",
  "participantContent": "Qblt0W_participantContent",
  "participantDetails": "Qblt0W_participantDetails",
  "participantInfo": "Qblt0W_participantInfo",
  "participantItem": "Qblt0W_participantItem",
  "participantsGroup": "Qblt0W_participantsGroup",
  "participantsGroups": "Qblt0W_participantsGroups",
  "participantsList": "Qblt0W_participantsList",
  "remark": "Qblt0W_remark",
});
